import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: '_sanitize',
  pure: true,
  standalone: false,
})
export class SanitizePipe implements PipeTransform {
  public transform(value: string | null | undefined): string {
    if (!value) return '';
    return value.replace(/\./g, '').replace(/\-/g, '').replace(/\//g, '');
  }
}
